/* eslint-disable no-shadow */

export enum OzonerStatus {
	lead = 'lead',
	inactive = 'inactive',
	active = 'active',
}

export const OzonerStatusValues = {
	lead: {
		title: 'Lead',
		color: 'yellow_100',
	},
	active: {
		title: 'Activo',
		color: 'green_300',
	},
	inactive: {
		title: 'Inactivo',
		color: 'neutral_700',
	},
};

export const ozonerFields = {
	firstName: 'Primer Nombre',
	middleName: 'Segundo Nombre',
	lastName: 'Primer Apellido',
	secondLastName: 'Segundo Apellido',
	city: 'Ciudad',
	curp: 'CURP',
	email: 'Correo electrónico',
	createdOn: 'Creado en',
	status: 'Estado',
	geolocations: 'Geolocalizaciones',
	account: 'Cuenta',
	comment: 'Comentario',
	rfc: 'RFC',
	fiscalStatus: 'Estatus fiscal',
	image: 'Imagen',
	documents: 'Documentos',
	createdAt: 'Fecha de creación',
	updatedAt: 'Fecha de actualización',
};

export enum RegimeDescriptionEnum {
	regime605 = 'RÉGIMEN DE SUELDOS Y SALARIOS E INGRESOS ASIMILADOS A SALARIOS',
	regime606 = 'RÉGIMEN DE ARRENDAMIENTO',
	regime607 = 'RÉGIMEN DE ENAJENACIÓN O ADQUISICIÓN DE BIENES',
	regime608 = 'RÉGIMEN DE LOS DEMÁS INGRESOS',
	regime609 = 'RÉGIMEN DE CONSOLIDACIÓN',
	regime610 = 'RÉGIMEN RESIDENTES EN EL EXTRANJERO SIN ESTABLECIMIENTO PERMANENTE EN MÉXICO',
	regime611 = 'RÉGIMEN DE INGRESOS POR DIVIDENDOS (SOCIOS Y ACCIONISTAS)',
	regime612 = 'RÉGIMEN DE LAS PERSONAS FÍSICAS CON ACTIVIDADES EMPRESARIALES Y PROFESIONALES',
	regime613 = 'RÉGIMEN INTERMEDIO DE LAS PERSONAS FÍSICAS CON ACTIVIDADES EMPRESARIALES',
	regime614 = 'RÉGIMEN DE LOS INGRESOS POR INTERESES',
	regime615 = 'RÉGIMEN DE LOS INGRESOS POR OBTENCIÓN DE PREMIOS',
	regime616 = 'SIN OBLIGACIONES FISCALES',
	regime617 = 'PEMEX',
	regime618 = 'RÉGIMEN SIMPLIFICADO DE LEY PERSONAS FÍSICAS',
	regime619 = 'INGRESOS POR LA OBTENCIÓN DE PRÉSTAMOS',
	regime620 = 'SOCIEDADES COOPERATIVAS DE PRODUCCIÓN QUE OPTAN POR DIFERIR SUS INGRESOS',
	regime621 = 'RÉGIMEN DE INCORPORACIÓN FISCAL',
	regime622 = 'RÉGIMEN DE ACTIVIDADES AGRÍCOLAS, GANADERAS, SILVÍCOLAS Y PESQUERAS PM',
	regime623 = 'RÉGIMEN DE OPCIONAL PARA GRUPOS DE SOCIEDADES',
	regime624 = 'RÉGIMEN DE LOS COORDINADOS',
	regime625 = 'RÉGIMEN DE LAS ACTIVIDADES EMPRESARIALES CON INGRESOS A TRAVÉS DE PLATAFORMAS TECNOLÓGICAS',
	regime626 = 'RÉGIMEN SIMPLIFICADO DE CONFIANZA',
}
